module.exports = __webpack_public_path__ + "static/media/ky.ef1f6537.svg";